import ComponentRegistry from "Fratello/Common/ComponentRegistry";

// Image Gallery
import ImageGalleryWidget from "Fratello/ImageGallery/Widgets/ImageGalleryWidget";
import ImageGalleryViewsImageGalleryView from "Fratello/ImageGallery/Views/ImageGalleryView";
import ImageGalleryViewsThumbView from "Fratello/ImageGallery/Views/ThumbView";
import ImageGalleryViewsDetailView from "Fratello/ImageGallery/Views/DetailView";
import ImageGalleryViewsVisualView from "../ImagesGallery/Views/VisualView";

// Widgets
ComponentRegistry.register({ImageGalleryWidget});

// Views
ComponentRegistry.register({ImageGalleryViewsImageGalleryView});
ComponentRegistry.register({ImageGalleryViewsThumbView});
ComponentRegistry.register({ImageGalleryViewsDetailView});
ComponentRegistry.register({ImageGalleryViewsVisualView});



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Components/ImageGallery.jsx